export const analyticsDashboardAppGroupIdGetCanvasesForFilter =
  "/analytics_dashboard/:app_group_id/get_canvases_for_filter";
